/**
 * Strings for who reacted (reactions.tsx) and the profile picture viewer
 * (2026-11-01).
 */
import type { Dict } from './core';

export const chatUiEn: Dict = {
  // "👍 reacted by Ali, Sara and 3 others" (Discord); names arrive isolated (U+2068)
  'rx.tip': '{e} reacted by {who}',
  'rx.tip.and': '{list} and {last}',
  'rx.tip.others': { one: '{list} and {n} other', other: '{list} and {n} others' },
  'rx.view': 'View reactions',
  'rx.list.title': 'Reactions',
  'rx.list.tabs': 'Reactions on this message',
  'rx.list.more': 'Show more',
  'rx.list.error': "Couldn't load who reacted.",
  'rx.list.remove': 'Remove {e} reaction',
  // the profile card: the picture opens large
  'prof.av.open': 'View profile picture',
  'prof.banner.open': 'View banner',
};
